module.exports = {
  API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT || "http://localhost:8000/api",
  API_KEY: process.env.REACT_APP_API_KEY
}